import { Observer } from 'rxjs';

export const SHORT_DATE_FORMAT = 'yyyy-MM-dd';
export const READABLE_SHORT_DATE_FORMAT = 'dd MMM yyyy';
export const READABLE_SHORT_DATE_FORMAT_WITH_TIME = 'dd MMM yyyy, HH:mm:ss';
export const MAX_ITEMS_IN_ACTION_BAR = 2;
export const DEFAULT_PAGE_SIZE = 25;
export const EMPTY_OBSERVER: Observer<any> = {
    next: () => {},
    error: err => {
        console.error(err);
    },
    complete: () => {}
};
export const DIGIHAVEN_PROTOCOL = 'digihaven://';
export const LOCATION_LEGACY_PROTOCOL = 'id/locatie/';
